import { MenuItem, TextField, Box, Typography, Avatar } from "@mui/material";

export default function DynamicDropdown({
    label,
    value,
    onChange,
    options,
    disabled = false,
    sx = {}
}) {
    const selected = options.find((opt) => opt.value === value);

    return (
        <TextField
            select
            size="small"
            label={label}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            dir="rtl"
            variant="standard"
            SelectProps={{
                renderValue: () =>
                    selected?.flagUrl && selected?.shortLabel ? (
                        // Case: country code dropdown (with flag)
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar
                                src={selected.flagUrl}
                                alt=""
                                variant="square"
                                sx={{ width: 20, height: 14 }}
                            />
                            <Typography fontSize="14px">
                                {selected.shortLabel}
                            </Typography>
                        </Box>
                    ) : (
                        // Default case
                        selected?.label || ''
                    )
            }}
            sx={{
                minWidth: 200,
                ...sx, // override with props
                "& .MuiInputBase-root": {
                    borderRadius: 2,
                    paddingY: 0,
                    flexDirection: "row-reverse",
                },
                "& .MuiOutlinedInput-input": {
                    paddingY: "8px",
                    textAlign: "right",
                    fontFamily: "'Tajawal'",
                },
                "& label": {
                    right: 24,
                    left: "auto",
                    transformOrigin: "right",
                    fontFamily: "'Tajawal'",
                },
                "& .MuiSvgIcon-root": {
                    left: 8,
                    right: "auto",
                },
            }}
        >
            {options.map((option) => (
                <MenuItem
                    key={option.value}
                    value={option.value}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    {option.flagUrl && (
                        <Avatar
                            src={option.flagUrl}
                            alt=""
                            variant="square"
                            sx={{ width: 20, height: 14 }}
                        />
                    )}
                    <Typography fontFamily="'Tajawal'" fontSize="14px">
                        {option.label}
                    </Typography>
                </MenuItem>
            ))}
        </TextField>
    );
}
